const TealiumPlugin = {
  install(Vue, options = {}) {
    const environment = process.env.VUE_APP_TEALIUM_ENV;
    const websitePlatform = options.websitePlatform;

    // --- #A Tealium Sync Script (synchronous) ---
    const tealiumSyncScript = document.createElement("script");
    tealiumSyncScript.type = "text/javascript";
    tealiumSyncScript.src = `https://tags.tiqcdn.com/utag/sony-marketing/sony-pro/${environment}/utag.sync.js`;
    tealiumSyncScript.async = false; // synchronous execution
    document.head.appendChild(tealiumSyncScript);

    // --- #B utag_data ---
    const utagDataScript = document.createElement("script");
    utagDataScript.type = "text/javascript";
    utagDataScript.innerHTML = `
       var utag_data = { 
           website_platform: '${websitePlatform}' 
       };
    `;
    document.head.appendChild(utagDataScript);

    // --- #C Tealium Async Script (dynamically insert after opening body) ---
    const tealiumAsyncScript = document.createElement("script");
    tealiumAsyncScript.type = "text/javascript";
    tealiumAsyncScript.innerHTML = `(function(a,b,c,d){
      a='https://tags.tiqcdn.com/utag/sony-marketing/sony-pro/${environment}/utag.js';
      b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;
      a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a); })();`;
    document.body.prepend(tealiumAsyncScript);
  }
};

export default TealiumPlugin;
